import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import React from "react";

const paragraphVariants = cva("leading-7 font-inter");

export interface ParagraphProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof paragraphVariants> {
  asChild?: boolean;
}

export const Paragraph = React.forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...props }, ref) => {
    return (
      <p
        className={cn("", paragraphVariants({ className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
